import { render, staticRenderFns } from "./CriterialTradeIn.vue?vue&type=template&id=70cdc48b"
import script from "./CriterialTradeIn.vue?vue&type=script&lang=js"
export * from "./CriterialTradeIn.vue?vue&type=script&lang=js"
import style0 from "./CriterialTradeIn.vue?vue&type=style&index=0&id=70cdc48b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports